module.exports = __webpack_public_path__ + "static/Beatrice Amann-Vesti-2ea883eb1a38a874dadb631f5d906949.png";